import {
  Button, Checkbox,
  Col, Dropdown,
  Input, Menu,
  Row,
  Space,
  Tooltip,
  Typography
} from 'antd';
import {
  EllipsisOutlined,
  FileExcelOutlined,
  SyncOutlined
} from '@ant-design/icons';
import {useEffect, useState} from "react";
import {FetchApiInterface} from "../../../../interfaces/FetchApi.interface";
import {AxiosResponse} from "axios";
import {ResponseInterface} from "../../../../interfaces/Response.interface";
import useFetch from "../../../../hooks/useFetch";
import useMessageUser from "../../../../hooks/useMessageUser";
import {IMonitoring} from "../models";
import {useTranslation} from "react-i18next";
import moment from "moment/moment";
import useExport from "../../../../hooks/comms/useExport";
import {getScopes} from "../helperComms";
import DownloadZipButton from "../../../Components/DownloadZipButton";
import {useNavigate} from "react-router-dom";
import PaginatedTable from "./PaginatedTable";
import {useRowSelection} from "../../../../hooks/useRowSelection";
import FilterModal from "../../../Components/FilterModal";
import ButtonSyncPhotos from "./ButtonSyncPhotos";
const { Search } = Input;
const { Title } = Typography;

function  TableOneCreateAgendaHistoryNew({ setReload }: { setReload: any }) {

  const { t } = useTranslation();
  const scopes = getScopes();

  const initialColumns = [
    {
      title: t('name'),
      dataIndex: 'cinScName',
      key: 'cinScName',
      visible: true,
      fixed: 'left',
    },
    {
      title: t('withPhotos'),
      dataIndex: 'withPhotos',
      key: 'withPhotos',
      visible: true,
      render: (item: string) => `${item ? 'Si' : 'No'}`,
    },
    {
      title: t('childStatusName'),
      dataIndex: 'childStatusName',
      key: 'childStatusName',
      visible: true,
      render: (item: string) => `${t(item)}`,
    },
    {
      title: t('up'),
      dataIndex: 'cinNombreComunidad',
      key: 'cinNombreComunidad',
      visible: true,
    },
    {
      title: t('gender'),
      dataIndex: 'cinScGenre',
      key: 'cinScGenre',
      visible: true,
    },
    {
      title: t('communityCode'),
      dataIndex: 'cinCodigoComunidad',
      key: 'cinCodigoComunidad',
      visible: true,
    },
    {
      title: t('age'), // Reemplaza 'Edad'
      dataIndex: 'cinScBornDate',
      key: 'cinScBornDate',
      visible: true,
      render: (value: any) => moment().diff(value, 'years'),
    },
    {
      title: t('birthDate'), // Reemplaza 'Nacimiento'
      dataIndex: 'cinScBornDate',
      key: 'cinScBornDate',
      visible: true,
    },
    {
      title: t('religion'), // Reemplaza 'Religión'
      dataIndex: 'q_2_2',
      key: 'q_2_2',
      visible: true,
    },
    {
      title: t('puId'), // Reemplaza 'PU Id'
      dataIndex: 'dpaId',
      key: 'dpaId',
      visible: false,
    },
    {
      title: t('fiscalYear'), // Reemplaza 'Fiscal Year'
      dataIndex: 'cinFiscalYear',
      key: 'cinFiscalYear',
      visible: false,
    },
    {
      title: t('interviewedPerson'), // Reemplaza 'Entrevistada'
      dataIndex: 'cinPersonaEntrevistada',
      key: 'cinPersonaEntrevistada',
      visible: false,
    },
    {
      title: t('interviewDate'), // Reemplaza 'Fecha Entrevista'
      dataIndex: 'cinFechaEntrevista',
      key: 'cinFechaEntrevista',
      visible: true,
      render: (item: string) => `${item ? moment(item).format('DD-MM-YYYY') : ''}`,
    },
    {
      title: t('createdAt'), // Reemplaza 'Fecha'
      dataIndex: 'updatedAt',
      key: 'updatedAt',
      visible: true,
      render: (item: string, row: any) => `${item ? moment(item).format('DD-MM-YYYY') : moment(row?.createdAt).format('DD-MM-YYYY')}`,
    },
    {
      title: 'Q. 1_1',
      dataIndex: 'opt_Q_1_1',
      key: 'opt_Q_1_1',
      visible: false,
    },
    {
      title: 'Q. 1_8',
      dataIndex: 'q_1_8',
      key: 'q_1_8',
      visible: false,
    },
    {
      title: 'Q. 1_10',
      dataIndex: 'q_1_10',
      key: 'q_1_10',
      visible: false,
    },
    {
      title: 'Q. 1_4',
      dataIndex: 'q_1_4',
      key: 'q_1_4',
      visible: false,
    },
    {
      title: 'Q. 1_15',
      dataIndex: 'q_1_15',
      key: 'q_1_15',
      visible: false,
    },
    {
      title: 'Q. 2_1',
      dataIndex: 'q_2_1',
      key: 'q_2_1',
      visible: false,
    },
    {
      title: 'Q. 2_3',
      dataIndex: 'q_2_3',
      key: 'q_2_3',
      visible: false,
    },
    {
      title: 'Q. 2_4',
      dataIndex: 'q_2_4',
      key: 'q_2_4',
      visible: false,
    },
    {
      title: 'Q. 2_5',
      dataIndex: 'q_2_5',
      key: 'q_2_5',
      visible: false,
    },
    {
      title: 'Q. 3_1',
      dataIndex: 'q_3_1',
      key: 'q_3_1',
      visible: false,
    },
    {
      title: 'Q. 3_10',
      dataIndex: 'q_3_10',
      key: 'q_3_10',
      visible: false,
    },
    {
      title: 'Q. 4_1',
      dataIndex: 'q_4_1',
      key: 'q_4_1',
      visible: false,
    },
    {
      title: 'Q. 4_2',
      dataIndex: 'q_4_2',
      key: 'q_4_2',
      visible: false,
    },
    {
      title: 'Q. 4_3',
      dataIndex: 'q_4_3',
      key: 'q_4_3',
      visible: false,
    },
    {
      title: 'Q. 4_4',
      dataIndex: 'q_4_4',
      key: 'q_4_4',
      visible: false,
    },
    {
      title: 'Q. 4_5',
      dataIndex: 'q_4_5',
      key: 'q_4_5',
      visible: false,
    },
    {
      title: 'Q. 4_6',
      dataIndex: 'q_4_6',
      key: 'q_4_6',
      visible: false,
    },
    {
      title: 'Q. 4_7',
      dataIndex: 'q_4_7',
      key: 'q_4_7',
      visible: false,
    },
    {
      title: 'Q. 4_8',
      dataIndex: 'q_4_8',
      key: 'q_4_8',
      visible: false,
    },
    {
      title: 'Q. 4_9',
      dataIndex: 'q_4_9',
      key: 'q_4_9',
      visible: false,
    },
    {
      title: 'Q. 4_10',
      dataIndex: 'q_4_10',
      key: 'q_4_10',
      visible: false,
    },
    {
      title: 'Q. 4_13',
      dataIndex: 'q_4_13',
      key: 'q_4_13',
      visible: false,
    },
    {
      title: 'Q. 5_1',
      dataIndex: 'q_5_1',
      key: 'q_5_1',
      visible: false,
    },
    {
      title: 'Q. 5_2',
      dataIndex: 'q_5_2',
      key: 'q_5_2',
      visible: false,
    },
    {
      title: 'Q. 5_3',
      dataIndex: 'q_5_3',
      key: 'q_5_3',
      visible: false,
    },
    {
      title: 'Q. 5_4',
      dataIndex: 'q_5_4',
      key: 'q_5_4',
      visible: false,
    },
    {
      title: 'Q. 5_5',
      dataIndex: 'q_5_5',
      key: 'q_5_5',
      visible: false,
    },
    {
      title: 'Q. 5_6',
      dataIndex: 'q_5_6',
      key: 'q_5_6',
      visible: false,
    },
    {
      title: 'Q. 5_7',
      dataIndex: 'q_5_7',
      key: 'q_5_7',
      visible: false,
    },
    {
      title: 'Q. 6_1',
      dataIndex: 'q_6_1',
      key: 'q_6_1',
      visible: false,
    },
    {
      title: 'Q. 6_2',
      dataIndex: 'q_6_2',
      key: 'q_6_2',
      visible: false,
    },
    {
      title: 'Q. 6_3',
      dataIndex: 'q_6_3',
      key: 'q_6_3',
      visible: false,
    },
    {
      title: 'Q. 6_4',
      dataIndex: 'q_6_4',
      key: 'q_6_4',
      visible: false,
    },
    {
      title: 'Q. 6_5',
      dataIndex: 'q_6_5',
      key: 'q_6_5',
      visible: false,
    },
    {
      title: 'Q. 6_6',
      dataIndex: 'q_6_6',
      key: 'q_6_6',
      visible: false,
    },
    {
      title: 'Q. 6_7',
      dataIndex: 'q_6_7',
      key: 'q_6_7',
      visible: false,
    },
    {
      title: 'Q. 7_1',
      dataIndex: 'q_7_1',
      key: 'q_7_1',
      visible: false,
    },
    {
      title: 'Q. 7_2',
      dataIndex: 'q_7_2',
      key: 'q_7_2',
      visible: false,
    },
    {
      title: 'Q. 8a_1',
      dataIndex: 'q_8a_1',
      key: 'q_8a_1',
      visible: false,
    },
    {
      title: 'Q. 8a_2',
      dataIndex: 'q_8a_2',
      key: 'q_8a_2',
      visible: false,
    },
    {
      title: 'Q. 8a_4_1',
      dataIndex: 'q_8a_4_1',
      key: 'q_8a_4_1',
      visible: false,
    },
    {
      title: 'Q. 8a_4_2',
      dataIndex: 'q_8a_4_2',
      key: 'q_8a_4_2',
      visible: false,
    },
    {
      title: 'Q. 8a_4_3',
      dataIndex: 'q_8a_4_3',
      key: 'q_8a_4_3',
      visible: false,
    },
    {
      title: 'Q. 8a_4_4',
      dataIndex: 'q_8a_4_4',
      key: 'q_8a_4_4',
      visible: false,
    },
    {
      title: 'Q. 8a_4_5',
      dataIndex: 'q_8a_4_5',
      key: 'q_8a_4_5',
      visible: false,
    },
    {
      title: 'Q. 8a_4_6',
      dataIndex: 'q_8a_4_6',
      key: 'q_8a_4_6',
      visible: false,
    },
    {
      title: 'Q. 8a_4_7',
      dataIndex: 'q_8a_4_7',
      key: 'q_8a_4_7',
      visible: false,
    },
    {
      title: 'Q. 8a_5_1',
      dataIndex: 'q_8a_5_1',
      key: 'q_8a_5_1',
      visible: false,
    },
    {
      title: 'Q. 8a_5_2',
      dataIndex: 'q_8a_5_2',
      key: 'q_8a_5_2',
      visible: false,
    },
    {
      title: 'Q. 8a_5_3',
      dataIndex: 'q_8a_5_3',
      key: 'q_8a_5_3',
      visible: false,
    },
    {
      title: 'Q. 8a_5_4',
      dataIndex: 'q_8a_5_4',
      key: 'q_8a_5_4',
      visible: false,
    },
    {
      title: 'Q. 8a_6_1',
      dataIndex: 'q_8a_6_1',
      key: 'q_8a_6_1',
      visible: false,
    },
    {
      title: 'Q. 8a_6_2',
      dataIndex: 'q_8a_6_2',
      key: 'q_8a_6_2',
      visible: false,
    },
    {
      title: 'Q. 8a_6_3',
      dataIndex: 'q_8a_6_3',
      key: 'q_8a_6_3',
      visible: false,
    },
    {
      title: 'Q. 8a_6_4',
      dataIndex: 'q_8a_6_4',
      key: 'q_8a_6_4',
      visible: false,
    },
    {
      title: 'Q. 8a_6_5',
      dataIndex: 'q_8a_6_5',
      key: 'q_8a_6_5',
      visible: false,
    },
    {
      title: 'Q. 8a_6_6',
      dataIndex: 'q_8a_6_6',
      key: 'q_8a_6_6',
      visible: false,
    },
  ];

  const [dataSource, setDataSource] = useState<Array<IMonitoring>>([]);
  const [columns, setColumns] = useState<Array<any>>(initialColumns);
  const [filterApply, setFilterApply] = useState<any>({});
  const { fetchApi, loading } = useFetch();
  const { exportExcel, downloading } = useExport();
  const [dataFilters, setDataFilters] = useState<any>({});
  const [searchText, setSearchText] = useState<string>('');
  const [pagination, setPagination] = useState({
    current: 0,
    pageSize: 20,
    total: 0,
  });
  const { showMessage }  = useMessageUser();
  const navigate = useNavigate();
  const { selectedRowKeys, rowSelection } = useRowSelection();

  useEffect(() => {
    if (!searchText) {
      const newFilterApply = { ...dataFilters };
      delete newFilterApply.search;
      setDataFilters(newFilterApply);
    }
  }, [searchText]);

  useEffect(() => {
    getTabla();
  }, [dataFilters]);

  const getTabla = (page = 1, size = pagination.pageSize) => {
    const dateSend = {
      isAfiliated: false,
      cinDonwload: false,
      ...dataFilters,
    };
    const dataSend: FetchApiInterface = {
      url: `/comms/get_child_info?page=${page - 1}&size=${size}`,
      data: dateSend,
    }
    fetchApi(dataSend).then(
      ({ data }: AxiosResponse<ResponseInterface>) => {
        if (data.status === 'success') {
          const dataResponse = data?.data;
          setDataSource(dataResponse?.content || []);
          setPagination({
            current: data?.data?.pageable?.pageNumber + 1,
            pageSize: size,
            total: data?.data?.totalElements,
          });
        } else {
          showMessage(data?.message, 'info');
        }
      }
    ).catch((reason: any) => {
      showMessage(reason?.message, 'error');
    });
  }

  const exportData = async () => {
    const dataSend = {
      isAfiliated: false,
      cinDonwload: false,
      ...dataFilters,
      size: pagination.pageSize,
      selectedRowKeys,
    };
    await exportExcel('/comms/donwload_excel_child_info', dataSend);
    getTabla();
    // generamos el timestamp para que se vuelva a cargar la tabla y le pasamos a la funcion setReload() el timestamp
    setReload(Date.now());
  }

  const handleSearch = (value: string) => {
    if (value) {
      setSearchText(value);
      setDataFilters((prevFilters: any) => ({ ...prevFilters, search: value }));
    }
  };

  // Codigo para filtrar las columnas
  // Filtra las columnas basándote en la visibilidad
  const visibleColumns = columns.filter(column => column.visible);

  // Menú para el Dropdown con Checkboxes para cada columna
  const menu = (
    <Menu>
      {columns.map(column => (
        <Menu.Item key={column.key}>
          <Checkbox
            checked={column.visible}
            onChange={e => handleVisibleChange(e, column.key)}
          >
            {column.title}
          </Checkbox>
        </Menu.Item>
      ))}
    </Menu>
  );

  // El Dropdown que muestra el menú
  const dropdown = (
    <Dropdown trigger={['click']} overlay={menu}>
      <Button type='primary' shape="circle" icon={<EllipsisOutlined />} />
    </Dropdown>
  );
  // Función para manejar el cambio en el estado de visibilidad de las columnas
  const handleVisibleChange = (e: any, columnName: any) => {
    const newColumns = columns.map(column => {
      if (column.key === columnName) {
        return { ...column, visible: e.target.checked };
      }
      return column;
    });
    setColumns(newColumns);
  };

  const handlePaginationChange = (page: number, pageSize?: number) => {
    setPagination((prev) => ({
      ...prev,
      current: page,
      pageSize: pageSize || prev.pageSize,
    }));
    getTabla(page, pageSize || pagination.pageSize);
  };

  return (
    <Row justify='end' gutter={[20, 20]}>
      <Col span={24}>
        <Title level={5}>{t('pendingUpdatesForSponsorship')}</Title>
      </Col>
      <Col span={24}>
        <Row justify='space-between'>
          <Col>
            <Space>
              <FilterModal
                  filters={dataFilters}
                  setFilters={setDataFilters}
                  setFilterApply={setFilterApply}
                  excludeFilters={['communityWorker', 'year', 'month', 'puCode', 'puOnly']}
              />
              {
                (scopes.includes('HISTORIAS_DESCARGAR')) && (
                  <Button type='primary' onClick={exportData} icon={<FileExcelOutlined />} loading={downloading}>
                    {t('exportExcel')}
                  </Button>
                )
              }
              <DownloadZipButton
                  url="/comms/download_images"
                  filters={{
                    isAfiliated: false,
                    cinDonwload: false,
                    selectedRowKeys,
                    ...dataFilters,
                  }}
              />
              <ButtonSyncPhotos getTabla={getTabla} isSCU={false} />
            </Space>
          </Col>
          <Col>
            <Space>
              <Search placeholder={t('search')} onSearch={handleSearch} allowClear enterButton value={searchText} onChange={(e) => setSearchText(e.target.value)} />
              {dropdown}
              <Tooltip title={t('reloadList')}>
                <Button icon={<SyncOutlined />} loading={loading} onClick={() => getTabla(0)} />
              </Tooltip>
            </Space>
          </Col>
        </Row>
      </Col>
      <Col span={24}>
        <PaginatedTable
            dataSource={dataSource}
            columns={visibleColumns}
            scroll={{ x: 2000 }}
            rowKey="cinId"
            total={pagination.total}
            current={pagination.current}
            pageSize={pagination.pageSize}
            onPaginationChange={handlePaginationChange}
            onPageSizeChange={handlePaginationChange}
            onRow={(record: any) => ({
              onClick: () => {
                sessionStorage.setItem('scDetail', JSON.stringify(record));
                navigate('/scuapp/create_agenda_detail');
              },
            })}
            rowSelection={rowSelection}
        />
      </Col>
    </Row>
  );
}

export default TableOneCreateAgendaHistoryNew;
